/**
 * Picks the message to show for a failed API response.
 *
 * The API attaches a machine-readable `code` to exactly one error — EMAIL_ALREADY_EXISTS, on
 * create-user and update-user. Every other failure is a plain throw carrying English developer
 * text and no `code`, so the absent-code branch is the common path, not the edge case: those
 * responses are shown exactly as the server worded them, which is no worse than before.
 *
 * Handlers that set the body themselves use `error`; a thrown error is rendered by the CORS
 * middleware as `{success: 0, message}`. Both are read here.
 *
 * @param {Function} t Translation function from withTranslation()
 * @param {object} response API response carrying `error` or `message`, and optionally `code`
 * @returns {string}
 */
export function serverErrorMessage(t, response) {
    if (response == null) {
        return '';
    }

    const text = response.error != null
        ? String(response.error)
        : (response.message != null ? String(response.message) : '');

    if (response.code == null) {
        return text;
    }

    // Falls through to the server's own wording for a code we have no translation for.
    return t('errors.' + response.code, {
        defaultValue: text !== '' ? text : String(response.code)
    });
}
